module.exports = __webpack_public_path__ + "static/media/icons.384dcc95.svg";